type TDefaultSortingColumns =
  | 'id'
  | 'name'
  | 'isActive'
  | 'title'
  | 'slug'
  | 'type'
  | 'status'
  | 'provider'
  | 'points'
  | 'currency'
  | 'country'
  | 'levelNumber'
  | 'level'
  | 'code'
  | 'email'
  | 'userId'
  | 'countOfGames'
  | 'countOfCollections'
  | 'verificationStatus'
  | 'cashBackType'
  | 'domain'
  | 'priority'
  | 'amount'
  | 'paymentMethod'
  | 'created'

const defaultSortingColumns: TDefaultSortingColumns[] = [
  "id",
  "name",
  "isActive",
  "title",
  "slug",
  "type",
  "status",
  "provider",
  "points",
  "currency",
  "country",
  "levelNumber",
  "level",
  "code",
  "email",
  "userId",
  "countOfGames",
  "countOfCollections",
  "verificationStatus",
  "cashBackType",
  "domain",
  "priority",
  "amount",
  "paymentMethod",
  "created"
];

export default defaultSortingColumns;

export {
  type TDefaultSortingColumns,
  defaultSortingColumns
};



